import { makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { useRetrospectiva } from "../context/RetrospectivaContext"
import { CointainerDados } from "./ContainerDados"
import { ContainerInsta } from "./ContainerInsta"
import { sweepArcsSvg } from "./Svg"

const useStyles = makeStyles(() => ({
    titulo: {
        fontSize: 35,
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,.55)",
        letterSpacing: 0.2,
        marginBottom: "10px",
    },
    subTitulo: {
        fontSize: "33px",
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,.55)",
        letterSpacing: 0.2,
    },
    conteudo: {
        fontSize: "3rem",
        lineHeight: 0.9,
        color: "white",
        fontWeight: 800,
        textShadow: "0px 10px 28px rgba(0,0,0,.6)",
        marginBottom: "10px",
    },
}))

export function ClienteNovos() {
    const classes = useStyles()
    const dadosRestrospectiva = useRetrospectiva()
    const gradient = "linear-gradient(180deg, #2b0f06 0%, #5a1e0f 55%, #7a1522 100%)"

    const formatacao = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })

    return (
        <ContainerInsta img={sweepArcsSvg} gradiente={gradient}>
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "radial-gradient(120% 70% at 50% 80%, rgba(0,0,0,.45) 0%, rgba(0,0,0,0) 55%)",
                    pointerEvents: "none",
                }}
            />

            <CointainerDados>
                <>
                    <Typography className={classes.titulo}>Você Atingiu</Typography>
                    <Typography className={classes.conteudo}>
                        {formatacao.format(dadosRestrospectiva?.clientes.novosClientes ?? 0)}
                    </Typography>
                    <Typography className={classes.subTitulo}>Novos Clientes</Typography>
                </>
            </CointainerDados>
        </ContainerInsta>
    )
}
